import React, { Fragment, createRef, useEffect, useContext } from 'react'
import { ProductCardDesktop } from './ProductCardDesktop'
import { ProductCardBig } from './ProductCardBig'
import { ProductCardMobile } from './ProductCardMobile/ProductCardMobile'
import { useIsMobile } from './useIsMobile'

export function Products({ accessories, context }) {
  const {
    cartItems,
    setCartItems
  } = useContext(context)

  const isMobile = useIsMobile()
  const productCardBigRef = createRef()
  const [selectedProduct, setSelectedProduct] = React.useState(null)

  const onClickViewDetails = (accessory) => {
    setSelectedProduct(accessory)
  }

  useEffect(() => {
    if (productCardBigRef.current) {
      const NAV_HEIGHT = jQuery('#main_header, #mg-configurator header').outerHeight() ?? 0
      const ADMIN_NAV_HEIGHT = jQuery('#wpadminbar').outerHeight() ?? 0
      const elementPosition = productCardBigRef.current.getBoundingClientRect().top

      window.scrollTo({
        top: elementPosition + window.pageYOffset - (NAV_HEIGHT + ADMIN_NAV_HEIGHT) - 16,
        behavior: 'smooth'
      })
    }
  }, [selectedProduct])

  return (
    <>
      {accessories.map((accessory) => {
        const isInCart = cartItems.find((item) => item.id === accessory.id)

        const onAddToCartClick = (e) => {
          e.preventDefault()

          let tempCartItems = {}
          if (isInCart) {
            tempCartItems = cartItems.filter((item) => item.id !== accessory.id)
          } else {
            tempCartItems = [...cartItems, accessory]
          }

          setCartItems(tempCartItems)
        }

        return isMobile ? (
          <ProductCardMobile
            key={accessory.id}
            accessory={accessory}
            isInCart={isInCart}
            onAddToCartClick={onAddToCartClick}
            context={context}
          />
        ) : (
          <Fragment key={accessory.id}>
            <ProductCardDesktop
              accessory={accessory}
              onClickViewDetails={onClickViewDetails}
              isSelected={selectedProduct === accessory}
              isInCart={isInCart}
              onAddToCartClick={onAddToCartClick}
              context={context}
            />
            {selectedProduct === accessory ? (
              <ProductCardBig
                innerRef={productCardBigRef}
                accessory={accessory}
                isInCart={isInCart}
                onAddToCartClick={onAddToCartClick}
                context={context}
              />
            ) : null}
          </Fragment>
        )
      })}
    </>
  )
}
